<!-- Название, дата, город гонки, выбор класса -->
<div class="grid">
  <div class="col-12">
    <div class="grid">
      <!-- Название, дата, город гонки -->
      <div class="col">
        <app-races-info [selectedRace]="selectedRace"></app-races-info>
      </div>

      <div class="col-fixed" style="width: 450px">
        <div class="grid">
          <!-- Фильтр списка участников -->
          <div class="col-6 center">
            <app-competitors-list-filter-selector (filterSelected)="refreshByFilter($event)"
              class="button-item"></app-competitors-list-filter-selector>
          </div>

          <!-- Выбор класса -->
          <div class="col-6 center">
            <app-class-selector [selectedRace]="selectedRace" [raceClasses]="raceClasses"
              [selectedClass]="selectedClass" [showOverAll]="false" (refresh)="refresh($event)"
              class="button-item"></app-class-selector>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Табы с кнопками протоколов -->
<p-tabView class="col-12 p-0" [(activeIndex)]="activeIndex" (onTabChange)="onTabChange($event)">
  <!-- Откр/закр регистрацию, массовое формирование заявок, техкарт -->
  <p-tabPanel header="{{ appSettings.translate[appSettings.selectedLang]['registration'] }}" leftIcon="pi pi-user">
    <div class="grid p-0">
      <!-- Открыть/закрыть регистрацию -->
      <div class="right-panel">
        {{ appSettings.translate[appSettings.selectedLang]['race_state'] }}
      </div>
      <div class="col">
        <p-dropdown [options]="raceStates" [(ngModel)]="raceState" (onChange)="queryChangeRaceState($event)">
          <ng-template let-item pTemplate="selectedItem">
            {{ appSettings.translate[appSettings.selectedLang]['race_state_' + item.label] }}
          </ng-template>
          <ng-template let-item pTemplate="item">
            {{ appSettings.translate[appSettings.selectedLang]['race_state_' + item.label] }}
          </ng-template>
        </p-dropdown>
      </div>
      <div class="col"></div>
      <!-- Сформировать все заявки -->
      <div class="col">
        <button type="button" (click)="selectApplicationFormForAll()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['form_application'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Сформировать все техкарты -->
      <div class="col">
        <button type="button" (click)="printAllTechCards()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['form_tech_cards'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Сформировать все лицензии мфр -->
      <div class="col" *ngIf="selectedRace.sportType.code === '0910007511Я'">
        <button type="button" (click)="participantToPrintLicense = null; dialogSportSubType = true" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['form_mfr_licenses'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Список участия в гонках (CSV из зала славы) -->
      <div class="col">
        <button type="button" (click)="downloadParticipationInRacesCsv()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['participation_in_races_csv'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Присвоить номера -->
      <div class="col" *ngIf="raceState < 2">
        <button type="button" (click)="dialogAssignNumbers()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['assign_numbers'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Удалить номера -->
      <div class="col" *ngIf="raceState < 2">
        <button type="button" (click)="deleteNumbers()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['delete_numbers'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Добавить участника -->
      <div class="col-12" *ngIf="raceState < 2 && selectedClass.clUid !== 'ALL'">
        <race-add-registration-by-org [user]="progressService.user" [selectedClass]="selectedClass"
          [raceClasses]="raceClasses" [disable]="false" [race]="selectedRace"></race-add-registration-by-org>
      </div>
    </div>
  </p-tabPanel>
  <!-- Протоколы перед стартом -->
  <p-tabPanel header="{{ appSettings.translate[appSettings.selectedLang]['protocols'] }}" leftIcon="pi pi-file">
    <div class="grid p-0">
      <!-- Печать списка участников кратко -->
      <div class="col">
        <button type="button" (click)="printRegistrationsListShort()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['registration_list_short'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Печать списка участников полно -->
      <div class="col">
        <button type="button" (click)="printRegistrationsListFull()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['registration_list_full'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Выгрузка списка участников полно -->
      <div class="col">
        <button type="button" (click)="printRegistrationsListFull(true)" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['registration_list_full_csv'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Выгрузка списка участников с ответами на вопросы анкеты -->
      <div class="col">
        <button type="button" (click)="downloadPollResultsCsv()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['download_questions_csv'] }}"
          class="width100 no-wrap"></button>
      </div>      
      <!-- Печать протокола техкомиссии -->
      <div class="col">
        <button type="button" (click)="printTechCheckProtocol()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['technical_protocol'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Печать медицинского протокола -->
      <div class="col">
        <button type="button" (click)="printMedicalProtocol()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['medical_protocol'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Печать протокола допущенных -->
      <div class="col">
        <button type="button" (click)="printApprovedProtocol()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['approved_protocol'] }}"
          class="width100 no-wrap"></button>
      </div>
    </div>
  </p-tabPanel>
  <!-- Протоколы результатов -->
  <p-tabPanel header="{{ appSettings.translate[appSettings.selectedLang]['result_protocols'] }}" leftIcon="pi pi-list">
    <div class="grid p-0">
      <!-- Печать протокола личного зачета -->
      <div class="col">
        <button type="button" (click)="printIndividualStandings()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['individual_standings'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Открывает диалог формирования сводных протоколов -->
      <div class="col">
        <button *ngIf="selectedClass.clUid != 'ALL'" type="button" (click)="clickSummaryStandingsDialog(true)" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['individual_summary_standings'] }}"
          class="width100 no-wrap"></button>
        <button *ngIf="selectedClass.clUid == 'ALL'" type="button" (click)="printIndividualStandings('overall')" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['overall_standings'] }}" class="width100"></button>
      </div>
      <!-- Печать протокола командного зачета -->
      <div class="col">
        <button type="button" (click)="printTeamStandings()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['team_standings'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Загрузка результатов из файла -->
      <div class="col">
        <button type="button" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['upload_results_from_file'] }}" icon="pi pi-upload"
          (click)="fileInput.click()" class="width100 no-wrap"></button>
        <input type="file" style="display: none" (change)="onFileSelect($event)" #fileInput />
      </div>
    </div>
  </p-tabPanel>
  <!-- Датчики -->
  <p-tabPanel header="{{ appSettings.translate[appSettings.selectedLang]['tags_panel'] }}" leftIcon="pi pi-wifi">
    <div class="grid p-0">
      <!-- Печать списка выданных трекеров -->
      <div class="col">
        <button type="button" (click)="printIssuedDevicesList('trackers')" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['issued_trackers'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Печать списка выданных датчиков хронометража -->
      <div class="col">
        <button type="button" (click)="printIssuedDevicesList('tags')" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['issued_tags'] }}"
          class="width100 no-wrap"></button>
      </div>
      <!-- Отметка возврата датчиков -->
      <div class="col">
        <button type="button" pButton label="{{ appSettings.translate[appSettings.selectedLang]['tags_return'] }}"
          class="width100 no-wrap" (click)="returnTag()"></button>
      </div>
    </div>
  </p-tabPanel>
  <!-- Настройки - отправка смс, выбор логотипов для протоколов -->
  <p-tabPanel header="{{ appSettings.translate[appSettings.selectedLang]['service_functions'] }}" leftIcon="pi pi-cog">
    <div class="grid p-0">
      <!-- Загрузить картинку -->
      <div class="col-12">
        <race-file-uploader group="race" mode="advanced"
          label="{{ appSettings.translate[appSettings.selectedLang]['add_image'] }}"
          (uploadEvent)="addAttachment($event)"></race-file-uploader>
      </div>
      <div class="col-12">
        <div class="grid p-0">
          <!-- Выбор левого логотипа -->
          <div class="col-4 p-0 center">
            <p-fieldset legend="{{ appSettings.translate[appSettings.selectedLang]['left_logo'] }}">
              <div class="grid p-0">
                <img *ngIf="selectedRace.protocolsLogoLeft"
                  src="{{ appSettings.settings.urlFileDownload }}/race/uid/{{ selectedRace.protocolsLogoLeft }}"
                  class="col-12 template_image" />
                <p-dropdown appendTo="body" class="col-12 no-wrap" [options]="progressService.templateImages"
                  [(ngModel)]="selectedRace.protocolsLogoLeft"
                  placeholder="{{ appSettings.translate[appSettings.selectedLang]['select_image'] }}"
                  (onChange)="afterLogoImageSelected()">
                </p-dropdown>
              </div>
            </p-fieldset>
          </div>
          <!-- Выбор центрального логотипа -->
          <div class="col-4 p-0 center">
            <p-fieldset legend="{{ appSettings.translate[appSettings.selectedLang]['center_logo'] }}">
              <div class="grid p-0">
                <img *ngIf="selectedRace.protocolsLogoCenter"
                  src="{{ appSettings.settings.urlFileDownload }}/race/uid/{{ selectedRace.protocolsLogoCenter }}"
                  class="col-12 template_image" />
                <p-dropdown appendTo="body" class="col-12 no-wrap" [options]="progressService.templateImages"
                  [(ngModel)]="selectedRace.protocolsLogoCenter"
                  placeholder="{{ appSettings.translate[appSettings.selectedLang]['select_image'] }}"
                  (onChange)="afterLogoImageSelected()"></p-dropdown>
              </div>
            </p-fieldset>
          </div>
          <!-- Выбор правого логотипа -->
          <div class="col-4 p-0 center">
            <p-fieldset legend="{{ appSettings.translate[appSettings.selectedLang]['right_logo'] }}">
              <div class="grid p-0">
                <img *ngIf="selectedRace.protocolsLogoRight"
                  src="{{ appSettings.settings.urlFileDownload }}/race/uid/{{ selectedRace.protocolsLogoRight }}"
                  class="col-12 template_image" />
                <p-dropdown appendTo="body" class="col-12 no-wrap" [options]="progressService.templateImages"
                  [(ngModel)]="selectedRace.protocolsLogoRight"
                  placeholder="{{ appSettings.translate[appSettings.selectedLang]['select_image'] }}"
                  (onChange)="afterLogoImageSelected()"></p-dropdown>
              </div>
            </p-fieldset>
          </div>
        </div>
      </div>
      <!-- Форма отправки смс -->
      <div class="col-12">
        <div class="grid p-1">
          <label class="col-12">{{ appSettings.translate[appSettings.selectedLang]['send_sms_title'] }}</label>
          <div class="col-12 p-1">
            <label class="col">{{ appSettings.translate[appSettings.selectedLang]['sms_text'] }}</label>
            <input class="col-10" pInputText id="smsText" [(ngModel)]="smsText" maxlength="{{ maxSmsLength }}"
              placeholder="{{ appSettings.getTranslate('sms_hint', [smsPrice.toString(), maxSmsLength.toString()]) }}" />
            <button class="col" pButton type="button"
              label="{{ appSettings.translate[appSettings.selectedLang]['send'] }}" icon="pi pi-envelope"
              (click)="sendSms()"></button>
          </div>
          <small [style.color]="smsText.length >= maxSmsLength ? 'red' : 'inherit'">
            {{ appSettings.getTranslate('sms_symbols_count', [smsText.length.toString(),
            calculateSmsCount().toString()]) }}
            <span *ngIf="smsText.length >= maxSmsLength">{{
              appSettings.translate[appSettings.selectedLang]['sms_max_symbols'] }}</span>
          </small>
        </div>
      </div>
    </div>
  </p-tabPanel>
  <!-- Статистика по гонке -->
  <p-tabPanel header="{{ appSettings.translate[appSettings.selectedLang]['statistic'] }}" leftIcon="pi pi-chart-bar">
    <div class="grid p-0">
      <!-- Список не зарегистрировавшихся -->
      <div class="col">
        <button type="button" (click)="unsucessRegistrations()" pButton
          label="{{ appSettings.translate[appSettings.selectedLang]['unsuccess_registrations'] }}"
          class="width100 no-wrap"></button>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>

<div class="col-12" *ngIf="selectedClass.clUid === 'ALL' && activeIndex !== 5">
  Итого участников: {{ totals.competitors }} оплачено {{ totals.fee }}, выдано трекеров {{ totals.gpsTrackers }},
  датчиков
  {{ totals.chronoTags }}
</div>

<!-- Таблица участников -->
<div class="col-12" *ngIf="activeIndex !== 5">
  <div *ngFor="let classData of selectedClasses" [ngClass]="{'height100': classData.registrations.length > 0}">
    <div class="class-header" *ngIf="selectedClass.clUid == 'ALL' && classData.clUid !== 'OVERALL_STANDINGS'">
      {{ classData.name }}
    </div>
    <app-documents-participants-table *ngIf="classData.clUid !== 'OVERALL_STANDINGS'" [race]="selectedRace"
      [classData]="classData" [raceClasses]="raceClasses" [filter]="filter"
      (onMenuOpen)="onMenuOpen($event)"></app-documents-participants-table>
    <div *ngIf="classData.clUid !== 'OVERALL_STANDINGS' && classData.registrations.length === 0" class="center">
      {{ appSettings.translate[appSettings.selectedLang]['no_data'] || 'Нет данных' }}
    </div>
  </div>
</div>

<!-- Таблица неудачно зарегистрировавшихся участников -->
<div class="col-12" *ngIf="activeIndex === 5">
  <p-table [value]="unsuccessRegistrations" sortMode="multiple">
    <ng-template pTemplate="colgroup">
      <colgroup>
        <col style="width: 120px" />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="date">Дата <p-sortIcon field="date"></p-sortIcon></th>
        <th pSortableColumn="user_name">Участник <p-sortIcon field="user.name"></p-sortIcon></th>
        <th pSortableColumn="user_age">Возраст <p-sortIcon field="user.age.age"></p-sortIcon></th>
        <th pSortableColumn="city">Город <p-sortIcon field="user.city"></p-sortIcon></th>
        <th pSortableColumn="phone">Телефон <p-sortIcon field="user.phone"></p-sortIcon></th>
        <th pSortableColumn="reason">Причина <p-sortIcon field="reason"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-unsuccessRegistration>
      <tr>
        <td>{{ unsuccessRegistration.date | date : 'yyyy-MM-dd' }}</td>
        <td>{{ unsuccessRegistration.user.name }}</td>
        <td>{{ unsuccessRegistration.user.age.age }}</td>
        <td>{{ unsuccessRegistration.user.city }}</td>
        <td>{{ unsuccessRegistration.user.phone }}</td>
        <td>
          <pre>{{ unsuccessRegistration.reason }}</pre>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Диалог для формирования сводных протоколов по некольким гонкам / заездам-->
<app-overval *ngIf="visibleOvervalResultDialog" [visibleDialog]="visibleOvervalResultDialog"
  [selectedRace]="selectedRace" [selectedClass]="selectedClass" (closeEvent)="clickSummaryStandingsDialog(false)"
  (printOvervalEvent)="printSummaryStandings($event)"></app-overval>

<!-- Диалог для отображения печатных форм -->
<app-form-documents *ngIf="displayPreview" (closeEvent)="clickPrintPreview()" [displayPreview]="displayPreview"
  [displayObj]="displayObj" [displayMrt]="displayMrt"></app-form-documents>

<!-- Диалог для ввода допданных об участнике -->
<p-dialog *ngIf="showModalForCompetitorInfo && dataModalForCompetitorInfo"
  [header]="appSettings.translate[appSettings.selectedLang]['competitor_info']" [modal]="true" [draggable]="true"
  [(visible)]="showModalForCompetitorInfo" [style]="{minWidth: '400px', maxWidth: '800px'}" [closable]="false">
  <p-editor [(ngModel)]="dataModalForCompetitorInfo.info" [style]="{ height: '200px' }">
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <button type="button" class="ql-bold" aria-label="Bold"></button>
        <button type="button" class="ql-italic" aria-label="Italic"></button>
        <button type="button" class="ql-underline" aria-label="Underline"></button>
      </span>
    </ng-template>
  </p-editor>
  <p-footer>
    <div class="ui-inputgroup document-buttons">
      <p-button [label]="appSettings.translate[appSettings.selectedLang]['cancel']"
        (click)="showModalForCompetitorInfo = false" styleClass="ui-button-danger"></p-button>
      <p-button [label]="appSettings.translate[appSettings.selectedLang]['ok']"
        (click)="saveCompetitorInfo()"></p-button>
    </div>
  </p-footer>
</p-dialog>

<!-- Диалог для ввода дисциплины спорта при печати лицензий мфр -->
<p-dialog [header]="appSettings.translate[appSettings.selectedLang]['sport_subtype']" [(visible)]="dialogSportSubType"
  [modal]="true" [style]="{ width: '300px' }">
  <div>
    <input [(ngModel)]="sportSubType" pInputText />
  </div>
  <p-footer>
    <p-button [label]="appSettings.translate[appSettings.selectedLang]['ok']"
      (click)="handleSportSubtypeSelected()"></p-button>
    <p-button [label]="appSettings.translate[appSettings.selectedLang]['cancel']"
      (click)="dialogSportSubType = false"></p-button>
  </p-footer>
</p-dialog>